import * as t from "ramda";
import { useCallback as o } from "react";
const l = () => ({
  makeResult: o((a) => {
    const r = t.propOr({}, "data", a), e = t.propOr("", "0", t.keys(r));
    return t.pathOr(null, ["data", e], a);
  }, [])
});
export {
  l as default
};
//# sourceMappingURL=useMakeResult.js.map
